import { render, staticRenderFns } from "./ConcernElement.vue?vue&type=template&id=462aa45a&scoped=true&"
import script from "./ConcernElement.vue?vue&type=script&lang=js&"
export * from "./ConcernElement.vue?vue&type=script&lang=js&"
import style0 from "./ConcernElement.vue?vue&type=style&index=0&id=462aa45a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462aa45a",
  null
  
)

export default component.exports